import Swiper from "swiper";
import {getOptionsFromJsonString} from "../../../default/global/js/utilities/options";

export function initTeaserSlider(query = document.querySelectorAll('.teaserSlider'),options = {}) {
    let defaultOptions = {
        breakpointItems: {
            xs: 1.15,
            sm: 2.15,
            md: 3,
            lg: 3,
            xlg: 3
        }
    };

    defaultOptions = {...defaultOptions, ...options};

    for (let teaserSlider of query) {
        let options = getOptionsFromJsonString(teaserSlider.getAttribute('data-options'), defaultOptions);
        let breakpoints = {
            xs: {
                items: options.breakpointItems.xs,
                centeredSlides: true,
            },
            sm: {
                items: options.breakpointItems.sm,
                centeredSlides: false,
            },
            md: {
                items: options.breakpointItems.md,
                centeredSlides: false,
            },
            lg: {
                items: options.breakpointItems.lg,
                centeredSlides: false,
            },
            xlg: {
                items: options.breakpointItems.xlg,
                centeredSlides: false,
            }
        };

        new Swiper(teaserSlider, {
            speed: 300,
            slidesPerView: 'auto',
            spaceBetween: 12,
            initialSlide: 1,
            centeredSlides: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            autoHeight: false,
            breakpoints: {
                0: {
                    slidesPerView: breakpoints.xs.items,
                    centeredSlides: breakpoints.xs.centeredSlides,
                },
                768: {
                    slidesPerView: breakpoints.sm.items,
                    centeredSlides: breakpoints.sm.centeredSlides,
                    initialSlide: 0,
                },
                1024: {
                    slidesPerView: breakpoints.md.items,
                    centeredSlides: breakpoints.md.centeredSlides,
                },
                1250: {
                    slidesPerView: breakpoints.lg.items,
                    centeredSlides: breakpoints.lg.centeredSlides,
                },
                1540: {
                    slidesPerView: breakpoints.xlg.items,
                    centeredSlides: breakpoints.xlg.centeredSlides,
                }
            }
        });
    }

}